import React from "react";
import OutputValidationSection from "./validation/OutputValidationSection";

export default function ValidationTab(props) {
  return <OutputValidationSection {...props} />;
}
